import { useState, useEffect } from 'react';
import { getListName, checkListExist } from '../helpers';
import { useAllInOneContext } from '../context';

export default function useTargetListEdit() {
  const { lists } = useAllInOneContext();

  const [targetList, setTargetList] = useState();
  const [listName, setListName] = useState();

  useEffect(() => {
    if ( lists && lists.length && checkListExist(targetList, lists)) 
    
      setListName(getListName(targetList, lists));
     
    
  }, [targetList]);

  return {
    targetList,
    setTargetList,
    listName,
  };
}
